
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom';
// formatDate is used by the table body and the export; it was called without being imported,
// so rendering a single row threw a ReferenceError.
import {baseUrl, limit, formatDate, formatSummaryReportValue} from "../../comman/config";
import * as XLSX from 'xlsx';


import { DateSessionReportFilter } from "../../components/Filter/DateSessionReportFilter";
import Loader from '../../components/Loader';
import { isFilterActive, matchFilterText, patchFilter } from "../../components/Filter/columnFilter";
import ColumnFilterRow from "../../components/Filter/ColumnFilterRow";
import { ItemName, itemSearchText, itemExportName } from "../../components/ItemName";

// The body columns in table order. The three header rows above them are grouped and stay as they
// are; this list drives the cells, the inline filter row and what each filter matches against.
// `text` is what the filter matches; a column adds `render` when the cell shows something else --
// Menu Item reads in Gujarati but is searched in either language (see components/ItemName).
const fmt = formatSummaryReportValue;
const COLUMNS = [
    { key: 'date',            text: (r) => formatDate(r.date) },
    { key: 'session',         text: (r) => r.session_name },
    { key: 'menu_item',       text: itemSearchText, render: (r) => <ItemName item={r} /> },
    { key: 'method',          text: (r) => r.methodName?.name ?? '-' },
    { key: 'maharaj',         text: (r) => r.maharaj?.maharaj_name ?? '-' },
    { key: 'count_est',       text: (r) => fmt(r.raw_material?.estimated_count ?? 0, 'estimated_count') },
    { key: 'count_prod',      text: (r) => fmt(r.food_qty ?? 0, 'food_qty') },
    { key: 'count_pass',      text: (r) => fmt(r.pass_issued ?? 0, 'pass_issued') },
    { key: 'count_dish',      text: (r) => fmt(r.final_dish_count ?? 0, 'final_dish_count') },
    { key: 'ras_std',         text: (r) => fmt(r.consumption_master?.ras_raw_mat_per_100_person ?? 0, 'ras_raw_mat_per_100_person') },
    { key: 'ras_planned',     text: (r) => fmt(r.raw_material.ras_qty_per_100_person ?? 0, 'ras_qty_per_100_person') },
    { key: 'ras_production',  text: (r) => fmt(r.production_ras ?? 0, 'production_ras') },
    { key: 'ras_consumed',    text: (r) => fmt(r.raw_mat_per_100_person ?? 0, 'raw_mat_per_100_person') },
    { key: 'raw_planned',     text: (r) => fmt(r.raw_material.planned_rm_qty ?? 0, 'planned_rm_qty') },
    { key: 'raw_actual',      text: (r) => fmt(r.batch_raw_material_qty ?? 0, 'batch_raw_material_qty') },
    { key: 'fg_planned',      text: (r) => fmt(r.std_fg_qty, 'std_fg_qty') },
    { key: 'fg_actual',       text: (r) => fmt(r.finishedQty ?? 0, 'finishedQty') },
    { key: 'excess_bowl',     text: (r) => fmt(r.excess_bowl_qty ?? 0, 'excess_bowl_qty') },
    { key: 'excess_fg',       text: (r) => fmt(r.excess_fg_qty ?? 0, 'excess_fg_qty') },
    { key: 'excess_rm',       text: (r) => fmt(r.excess_rm_qty ?? 0, 'excess_rm_qty') },
    { key: 'fgpp_std',        text: (r) => fmt(r.std_fg_consumption_per_person ?? 0, 'std_fg_consumption_per_person') },
    { key: 'fgpp_actual',     text: (r) => fmt(r.fg_consumption_per_person ?? 0, 'fg_consumption_per_person') },
    { key: 'ratio_std',       text: (r) => fmt(r.consumption_master?.rm_to_fg_ratio ?? 0, 'rm_to_fg_ratio') },
    { key: 'ratio_actual',    text: (r) => fmt(r.current_rm_to_fg_ratio ?? 0, 'current_rm_to_fg_ratio') },
    { key: 'rmbowl_std',      text: (r) => fmt(r.std_rm_to_bowl_ratio ?? 0, 'std_rm_to_bowl_ratio') },
    { key: 'rmbowl_actual',   text: (r) => fmt(r.current_rm_to_bowl_ratio ?? 0, 'current_rm_to_bowl_ratio') },
    { key: 'ppb_planned',     text: (r) => fmt(r.person_per_bowl ?? 0, 'person_per_bowl') },
    { key: 'ppb_actual',      text: (r) => fmt(r.avg_person_per_bowl ?? 0, 'avg_person_per_bowl') },
    { key: 'bowl_std',        text: (r) => fmt(r.std_one_bowl_qty ?? 0, 'std_one_bowl_qty') },
    { key: 'bowl_actual',     text: (r) => fmt(r.no_of_rotis_in_1_bowl_icebox ?? 0, 'no_of_rotis_in_1_bowl_icebox') },
    { key: 'density_std',     text: (r) => fmt(r.std_density ?? 0, 'std_density') },
    { key: 'density_live',    text: (r) => fmt(r.density, 'density') },
];

function List() {

    const today = new Date().toISOString().split("T")[0];    
    const [filteredList, setFilteredList] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [session, setSession] = useState("");
    const [item, setItem] = useState("");
    const [method, setMethod] = useState("");
    const [summary, setSummary] = useState("");
    const formattedFromDate = new Date(new Date().setMonth(new Date().getMonth() - 15)).toISOString().split('T')[0];
    // Inline per-column filters: { [colKey]: { op, v1, v2 } }, matched against the cell's own text.
    const [filters, setFilters] = useState({});
    const setColFilter = (key, patch) => setFilters(prev => patchFilter(prev, key, patch));
    const activeFilterCols = COLUMNS.filter(c => isFilterActive(filters[c.key]));
    const summaryRows = filteredList.filter(item => item.summary);
    const visibleRows = summaryRows.filter(r => activeFilterCols.every(c => matchFilterText(c.text(r), filters[c.key])));

    useEffect(() => {
        getShortageList();
    }, []);

    useEffect(() => {
        getShortageList(); 
    }, [fromDate,toDate, session, item, method]);


    useEffect(() => {
        let filterelist;
        // console.log(method);
        if(method && method.length > 0){
            const methodIds = method.map(method => method.value);
            filterelist = reportList.filter((item) => item.measurements && methodIds.includes(item.measurements));
        } else{
            filterelist = reportList.filter((item) => item.measurements);
        }  
        setFilteredList(filterelist);
    }, [method, reportList]);
    const getShortageList = async () => {
        
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/reports/master_report?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&session=${encodeURIComponent(JSON.stringify(session))}&item=${encodeURIComponent(JSON.stringify(item))}&method=${encodeURIComponent(JSON.stringify(method))}&itemFilter=and`, {
           
        });
        setPopupOpen(false);
        setReportList(response.data.data);
        setFilteredList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const handelFilterChange= (fromDate, toDate, session, item, method) => {
        console.log(summary);
        setFromDate(fromDate);
        setToDate(toDate);
        setSession(session);
        setItem(item);
        setMethod(method);
        
        
    };

    const hadelSummary = (summary) => {
        setSummary(summary);
    }
   
    // const handleExport = () => {
    //     const header = ["Date", "Session", "Menu Item", "Measure Method", "Estimated", "Production","Pass Issued", "Dish Issued", "Planned", "Actual", "Planned", "Actual","Bowl", "FG", "RM", "STD.","Planned", "Actual", "Std.", "Actual", "Std.", "Actual", "Std.", "Actual", "Std.", "Actual" , "Std.", "Actual", "Std.", "Live"];
    //     const extraHeader = ["", "", "", "", "","", "Count", "","RAS -", "RM Consumption","", "Raw Qty", "", "Finished Qty", "","", "Excess Qty",  "Per Person", "FG Consumption", "Per Person", "RM To FG Ratio", "","Raw Material To", "Bowl ratio", "Avg Person", "Per Bowl", "1 Bowl Qty", "", "Density", ""];
    //     const unitheader = ["", "", "", "", "Persons", "Persons", "Persons", "Persons","","", "", "Kgs.", "Kgs.", "Kgs.", "Kgs.","Nos.", "Kgs.", "Kgs.",  "Kgs.", "Kgs.", "", "", "", "", "Persons", "Persons" , "Kgs.", "Kgs.", "", ""];
    //     const csv = [extraHeader, header, unitheader].concat(
    //         filteredList.filter(item => item.summary).map((item, index) => {
    //             let resultArray = [];
    //             if(item.summary){
    //             resultArray.push(formatDate(item.date));
    //             resultArray.push(item.session_name);
    //             resultArray.push(`${item.item_name} (${item.eng_name})`);
    //             resultArray.push(item.methodName?.name ?? '-');
    //             resultArray.push(item.raw_material?.estimated_count);
    //             resultArray.push(item.food_qty ?? 0);
    //             resultArray.push(item.pass_issued ?? 0);
    //             resultArray.push(item.final_dish_count ?? 0);
    //             resultArray.push(item.raw_material.ras_qty_per_100_person);
    //             resultArray.push(item.consumption_master?.ras_raw_mat_per_100_person ?? 0);
    //             resultArray.push(item.raw_mat_per_100_person ?? 0);
    //             resultArray.push(item.raw_material.planned_rm_qty);
    //             resultArray.push(item.batch_raw_material_qty);
    //             resultArray.push(item.std_fg_qty);
    //             resultArray.push(item.finishedQty ?? 0);
    //             resultArray.push(item.excess_bowl_qty ?? 0);
    //             resultArray.push(item.excess_fg_qty ?? 0);
    //             resultArray.push(item.excess_rm_qty ?? 0);
    //             resultArray.push(item.std_fg_consumption_per_person ?? 0);
    //             resultArray.push(item.fg_consumption_per_person ?? 0);
    //             resultArray.push(item.consumption_master?.rm_to_fg_ratio ?? 0);
    //             resultArray.push(item.current_rm_to_fg_ratio ?? 0);
    //             resultArray.push(item.std_rm_to_bowl_ratio ?? 0);
    //             resultArray.push(item.current_rm_to_bowl_ratio);
    //             resultArray.push(item.std_avg_person_per_bowl ?? 0);
    //             resultArray.push(item.person_per_bowl ?? 0);
    //             resultArray.push(item.std_one_bowl_qty ?? 0);
    //             resultArray.push(item.no_of_rotis_in_1_bowl_icebox ?? 0);
    //             resultArray.push(item.std_density ?? 0);
    //             resultArray.push(item.density ?? "-");}
    //             return resultArray.join(',');
    //         })
    //     ).join('\n');
    //     const blob = new Blob([csv], { type: 'text/csv' });
    //     const url = URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.setAttribute('href', url);
    //     a.setAttribute('download', "summary_report");
    //     a.click();
    // }

    const handleExport = () => {
        const header = ["Date", "Session", "Menu Item", "Measure Method", "Estimated", "Production", "Pass Issued", "Dish Issued", "Planned", "Actual", "Planned", "Actual", "Bowl", "FG", "RM", "STD.", "Planned", "Actual", "Planned", "Actual", "Std.", "Actual", "Std.", "Actual", "Planned", "Actual", "Std.", "Actual", "Std.", "Live"];
        const extraHeader = ["", "", "", "", "", "", "Count", "", "RAS -", "RM Consumption", "", "Raw Qty", "", "Finished Qty", "", "", "Excess Qty", "Per Person", "FG Consumption", "Per Person", "RM To FG Ratio", "", "Raw Material To", "Bowl ratio", "Avg Person", "Per Bowl", "1 Bowl Qty", "", "Density", ""];
        const unitHeader = ["", "", "", "", "Persons", "Persons", "Persons", "Persons", "", "", "", "Kgs.", "Kgs.", "Kgs.", "Kgs.", "Nos.", "Kgs.", "Kgs.", "Kgs.", "Kgs.", "", "", "", "", "Persons", "Persons", "Kgs.", "Kgs.", "", ""];

        // Create a 2D array of headers and data
        const data = [extraHeader, header, unitHeader];

        // Add rows of data from `filteredList`
        // Exports what the table shows -- the inline filters narrow the file too.
        visibleRows.forEach(item => {
            const resultArray = [
                formatDate(item.date),
                item.session_name,
                itemExportName(item),
                item.methodName?.name ?? '-',
                formatSummaryReportValue(item.raw_material?.estimated_count, 'estimated_count'),
                formatSummaryReportValue(item.food_qty ?? 0, 'food_qty'),
                formatSummaryReportValue(item.pass_issued ?? 0, 'pass_issued'),
                formatSummaryReportValue(item.final_dish_count ?? 0, 'final_dish_count'),
                formatSummaryReportValue(item.raw_material.ras_qty_per_100_person, 'ras_qty_per_100_person'),
                formatSummaryReportValue(item.consumption_master?.ras_raw_mat_per_100_person ?? 0, 'ras_raw_mat_per_100_person'),
                formatSummaryReportValue(item.raw_mat_per_100_person ?? 0, 'raw_mat_per_100_person'),
                formatSummaryReportValue(item.raw_material.planned_rm_qty, 'planned_rm_qty'),
                formatSummaryReportValue(item.batch_raw_material_qty, 'batch_raw_material_qty'),
                formatSummaryReportValue(item.std_fg_qty, 'std_fg_qty'),
                formatSummaryReportValue(item.finishedQty ?? 0, 'finishedQty'),
                formatSummaryReportValue(item.excess_bowl_qty ?? 0, 'excess_bowl_qty'),
                formatSummaryReportValue(item.excess_fg_qty ?? 0, 'excess_fg_qty'),
                formatSummaryReportValue(item.excess_rm_qty ?? 0, 'excess_rm_qty'),
                formatSummaryReportValue(item.std_fg_consumption_per_person ?? 0, 'std_fg_consumption_per_person'),
                formatSummaryReportValue(item.fg_consumption_per_person ?? 0, 'fg_consumption_per_person'),
                formatSummaryReportValue(item.consumption_master?.rm_to_fg_ratio ?? 0, 'rm_to_fg_ratio'),
                formatSummaryReportValue(item.current_rm_to_fg_ratio ?? 0, 'current_rm_to_fg_ratio'),
                formatSummaryReportValue(item.std_rm_to_bowl_ratio ?? 0, 'std_rm_to_bowl_ratio'),
                formatSummaryReportValue(item.current_rm_to_bowl_ratio, 'current_rm_to_bowl_ratio'),
                formatSummaryReportValue(item.person_per_bowl ?? 0, 'person_per_bowl'),
                formatSummaryReportValue(item.avg_person_per_bowl ?? 0, 'avg_person_per_bowl'),
                formatSummaryReportValue(item.std_one_bowl_qty ?? 0, 'std_one_bowl_qty'),
                formatSummaryReportValue(item.no_of_rotis_in_1_bowl_icebox ?? 0, 'no_of_rotis_in_1_bowl_icebox'),
                formatSummaryReportValue(item.std_density ?? 0, 'std_density'),
                formatSummaryReportValue(item.density, 'density')
            ];
            data.push(resultArray);
        });

        // Create a new workbook and worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Summary Report");

        // Export to XLSX file
        XLSX.writeFile(workbook, `Summary_Report_${fromDate ? '_' + formatDate(fromDate) : ''}to${toDate ? '_' + formatDate(toDate) : ''}${session?.label ? '_' + session.label : ''}.xlsx`);
    };

    
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).format(date);
      };
      


    return (
        <div className="p-4">
            {popupOpen && <Loader/>}
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-2xl font-bold">Summary Report</h1>
                <div>
                    <Link to="/">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Back</button>
                    </Link>
                </div>
            </div>
            <div className="relative shadow-md sm:rounded-lg">
            <DateSessionReportFilter 
            handleFilterChange={handelFilterChange} 
            hadelSummary={hadelSummary} 
            handleExport={handleExport}
            handleClearFilters={() => setFilters({})}
            defaultFromDate={formattedFromDate}
            defaultToDate={today} 
    
            />


                <div className="overflow-x-auto">
                <table className="w-full  text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            
                            <th scope="col" className="px-2 py-1 border border-black text-center "></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" colSpan={4} className="px-4 py-3 border border-black text-center">Count</th>
                            <th scope="col" colSpan={4} className="px-2 py-1 border border-black text-center bg-red-400 ">RAS - RM consumption per 100 person</th>
                            <th scope="col" colSpan={2} className="px-2 py-1 border border-black text-center ">Raw Qty.</th>
                            <th scope="col" colSpan={2} className="px-2 py-1 border border-black text-center ">Finished Qty.</th>
                            <th scope="col" colSpan={3} className="px-2 py-1 border border-black text-center ">Excess Qty.</th>
                            <th scope="col" colSpan={2} className="px-2 py-1 border border-black text-center ">FG Consumption Per Person</th>
                            <th scope="col" colSpan={2} className="px-2 py-1 border border-black text-center ">RM to FG Ratio</th>
                            {/* Hidden: Raw Material to Bowl ratio, Avg persons per bowl, 1 Bowl Qty., Density */}
                        </tr>
                        <tr>
                        
                            <th scope="col" className="px-2 py-1 border border-black text-center">Date</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Session</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Menu Item</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Measure Method</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Maharaj Name</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Estimated</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Production</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Pass Issued</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Dish Issued</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center bg-red-400">Std.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center bg-red-400">Planned</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center bg-red-400">Production</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center bg-red-400">Consumed</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Planned</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Actual</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Planned</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Actual</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Bowl</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">FG</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">RM</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Planned</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Actual</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Std.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Actual</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Std.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Actual</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Planned</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Actual</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Std.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Actual</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Std.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Live</th>
                        </tr>
                        <tr>    
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Persons</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Persons</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Persons</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Persons</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Kgs.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Kgs.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Kgs.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Kgs.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Nos.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Kgs.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Kgs.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Kgs.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center">Kgs.</th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                            {/* Hidden: bowl ratio, avg person, bowl qty, density unit cells */}
                        </tr>
                        {/* Inline per-column filter row (contains / = / ≤ / ≥ / between / not between) */}
                        <ColumnFilterRow
                            thClassName="px-1 py-1 border border-black bg-gray-50 dark:bg-gray-700 align-top"
                            cols={COLUMNS.map(c => ({ key: c.key }))}
                            filters={filters}
                            onChange={setColFilter} />
                    </thead>
                    <tbody>
                    {visibleRows.map((item, index) => (
                         <tr key={index} className={`${item.methodName?.id == 1 ? 'bg-blue-200' : (item.methodName?.id == 2 ? 'bg-orange-200' : 'bg-lime-200')} border border-black-b`}>
                            {COLUMNS.map(c => (
                                <td key={c.key} className="px-2 py-1 border border-black text-center">{c.render ? c.render(item) : c.text(item)}</td>
                            ))}
                        </tr>))}
                    {visibleRows.length === 0 && (
                        <tr><td className="px-2 py-4 text-center text-gray-500" colSpan={COLUMNS.length}>
                            {activeFilterCols.length ? 'No rows match the filters.' : 'No records found.'}
                        </td></tr>
                    )}
                    </tbody>
                </table>
                </div>
            </div>
        </div>
  );
}

export default List;